import { TextLinkWidget } from '@tableau/widgets';
import React from 'react';

import { HelpService } from '~commonInfra/services/HelpService';

import { Messages } from '../../../codegen/Localize';
import { SettingsSection } from '../../components/common/SettingsSection';
import {componentRegistryEntry} from '../../general-settings/components/SettingsComponentRegistryFunctions';
import { learnMoreStyle} from '../../styles/CommonStyles';

export function BridgeSettingsSummarySection() {
  return (
    <SettingsSection title={Messages.siteRemoteAgentSettingsSection()}
                     testId={'bridge-settings-summary-section'}
                     description={renderDescription()}/>
  );
}

function renderDescription() {
    return <>
      <span data-tb-test-id='bridge-settings-summary'>{Messages.siteRemoteAgentSettingsDescription_v2()}</span>
      <TextLinkWidget testId={'bridge-settings-summary-learn-more'}
                      className={learnMoreStyle}
                      href={HelpService.getServerHelpUrlByCategory('bridge-live-query')}
                      target={'_blank'}>
      {Messages.siteRemoteAgentSettingsLearnMore()}
      </TextLinkWidget>
      </>;
}

/* for registering the component in settings registry */
export const BridgeSettingsSummarySectionSpecs = componentRegistryEntry({
  name: 'BridgeSettingsSummarySection',
  component: BridgeSettingsSummarySection
});
